import { render } from "./FooterStreekfondsoostvlaanderen.vue?vue&type=template&id=03fa0562&scoped=true"
import script from "./FooterStreekfondsoostvlaanderen.vue?vue&type=script&lang=js"
export * from "./FooterStreekfondsoostvlaanderen.vue?vue&type=script&lang=js"

import "./FooterStreekfondsoostvlaanderen.vue?vue&type=style&index=0&id=03fa0562&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fa0562"]])

export default __exports__